export default {
  user:null,
  license: null,
  picture: null,
  editLicenceCategory: null,
  selectedLicenseCategory: null,
  inputForm: {},
  pictureSrc: null,
}
